(async () => {
    const { Core } = await importModule('Core');
    const { fetchHTML, $replaceContent } = await importModule('Utils');

    customElements.define('collection-provider', class extends Core {

        elements = {
            form: '[data-collection-form]',
            drawerForm: '[data-collection-drawer-form]',
            dynamicBlocks: '*[data-collection-dynamic-block]'
        }

        subscriptions = {
            'filter:change': '_onFilterChange',
            'navigation:change': '_onFilterChange'
        }

        cache = {};
        activeRequestId = 0;

        render() {
            this.subscribe('filter:change');
            this.subscribe('navigation:change');
        }
        
        async _onFilterChange(data) {
            const requestId = this.nextRequestId;

            this._getUrlParams(data);
            this._updateHistory();
            this._scrollToTop();
            try {
                await this._updateDynamicBlocks(requestId);
                if (this.isActiveRequest(requestId)) {
                    this.publish('collection:updated');
                }
            } catch (error) {
                if (this.isActiveRequest(requestId)) {
                    this.publish('collection:error', { error });
                }
            }
        }

        _getUrlParams(data) {
            this.urlParams = data?.url
                ? new URL(`${window.location.origin}${data.url}`).searchParams
                : new URLSearchParams(new FormData(this.$currentForm));
        }

        _updateHistory() {
            window.history.pushState({}, null, `${window.location.pathname}?${this.urlParams.toString()}`);
        }

        async _updateDynamicBlocks(requestId) {
            const doc = await this._getDoc(requestId);

            if (!this.isActiveRequest(requestId) || !doc) {
                return;
            }

            this.$dynamicBlocks.map($block => {
                const nextBlock = doc.getElementById($block.id);

                if (nextBlock) {
                    $replaceContent(
                        $block,
                        nextBlock
                    );
                }
            });
            
        }

        async _getDoc(requestId) {
            const urlParamsStr = this.urlParams.toString();
            if(this.cache[urlParamsStr]) {
                return this.cache[urlParamsStr];
            }

            this.publish('collection:loading', { requestId });
            return this._fetchDoc(urlParamsStr);
        }

        async _fetchDoc(urlParamsStr) {
            const fetchParams = new URLSearchParams(urlParamsStr);
            fetchParams.append('section_id', this.sectionId);
            const doc = await fetchHTML(`${this.getAttribute('collection-url')}?${fetchParams.toString()}`);
            this.cache[urlParamsStr] = doc;
            return doc;
        }

        _scrollToTop() {
            window.scrollTo({
                top: this.topPoint,
                behavior: 'smooth',
            });
        }

        get topPoint() {
            const headerHeight = document.documentElement.style.getPropertyValue('--header-height')?.replace('px', '');
            return headerHeight ? this.offsetTop - headerHeight : this.offsetTop;
        }

        get $currentForm() {
            if(!this.$form) {
                return this.$drawerForm;
            }
            return this.onMobile ? this.$drawerForm : this.$form;
        }

        get onMobile() {
            return window.matchMedia('(max-width: 992px)').matches;
        }

        get nextRequestId() {
            this.activeRequestId += 1;
            return this.activeRequestId;
        }

        isActiveRequest(requestId) {
            return requestId === this.activeRequestId;
        }
    })
})();
